<template>
  <div>
    <!-- Modal Backdrop -->
    <div v-if="isVisible" class="customl-modal-add-backdrop" @click="closeModal"></div>
    
    <!-- Modal Container -->
    <div v-if="isVisible" class="customl-modal-add-container">
      <div class="customl-modal-add-content">
        <!-- Modal Header -->
        <div class="customl-modal-add-header">
          <div class="header-content">
            <i class="bx bx-user-plus mr-2"></i>
            <h3>{{ getTranslations('expression_606') || 'Criar Novo Contato' }}</h3>
          </div>
          <button class="close-button" @click="closeModal">
            <i class="bx bx-x"></i>
          </button>
        </div>
        
        <!-- Modal Body -->
        <div class="customl-modal-add-body">
          <!-- FORMULÁRIO | CARD INFORMANDO EXISTÊNCIA DE CONTATO E/OU TICKET-->
          <div v-if="addlead_step === 2">
            <div class="customl-modal-add-form-container">
              <!-- Primeiro Nome - Campo vertical -->
              <div class="customl-modal-add-form-group">
                <label class="customl-modal-add-form-label">
                  {{ getTranslations("expression_42") || 'Nome' }}
                  <span class="customl-modal-add-required-field" v-b-tooltip.right :title="getTranslations('expression_617') || 'Campo obrigatório'">*</span>
                </label>
                <input
                  type="text"
                  v-model="new_lead.name"
                  class="customl-modal-add-form-input"
                  :placeholder="getTranslations('expression_818')"
                />
              </div>
              
              <!-- Número de telefone - Campo vertical com DDI e número na mesma linha -->
              <div class="customl-modal-add-form-group">
                <label class="customl-modal-add-form-label">
                  {{ getTranslations("expression_54") || 'Telefone' }}
                  <span class="customl-modal-add-required-field" v-b-tooltip.right :title="getTranslations('expression_617') || 'Campo obrigatório'">*</span>
                </label>
                <div class="customl-modal-add-customl-modal-add-phone-input-container">
                  <div class="country-dropdown">
                    <vue-country-dropdown
                        @onSelect="onSelectDDI"
                        :preferredCountries="['BR', 'US', 'ES']"
                        :onlyCountries="channels.onlyCountries"
                        :enabledFlags="true"
                        :enabledCountryCode="true" 
                        :immediateCallSelectEvent="true" 
                        :showNameInput="false"
                        :showNotSelectedOption="false" 
                        :notSelectedOptionText="'Selecione'">
                      </vue-country-dropdown>
                  </div>
                  <div class="customl-modal-add-phone-input">
                    <input
                      type="text"
                      id="phoneNumber"
                      v-model="new_lead.phone_without_ddi"
                      class="customl-modal-add-form-input"
                      :placeholder="getTranslations('expression_664')"
                      :maxlength="parseInt(new_lead.phone_ddi) === 55 ? 11 : 14"
                    />
                  </div>
                </div>
                <span v-if="whatsapp_not_exists" class="error-message">
                  Este número de WhatsApp não existe.
                </span>
              </div>
              
              <!-- E-mail - Campo vertical -->
              <div class="customl-modal-add-form-group">
                <label class="customl-modal-add-form-label">{{ getTranslations("expression_161") || 'E-mail' }}</label>
                <input
                  type="email"
                  v-model="new_lead.email"
                  class="customl-modal-add-form-input"
                  placeholder="E-mail"
                  @blur="validateEmail"
                />
                <span v-if="emailError" class="error-message">
                  {{ getTranslations('expression_1387') }}
                </span>
              </div>
              
              <!-- Canal - Campo vertical -->
              <div class="customl-modal-add-form-group">
                <label class="customl-modal-add-form-label">
                  {{ getTranslations("expression_4") || 'Canal' }}
                  <span class="customl-modal-add-required-field" v-b-tooltip.right :title="getTranslations('expression_617') || 'Campo obrigatório'">*</span>
                </label>
                <select
                  v-model="new_lead.channel_id"
                  class="customl-modal-add-form-select"
                >
                  <option :value="null" disabled>
                    {{ getTranslations("expression_285") || 'Selecione' }}
                  </option>
                  <option v-for="channel in getChannelsArray('type_key', 0)" :key="channel.id" :value="channel.id"
                        v-if="channel.parameter
                              && channel.parameter.modules.active === 1
                              && channel.status_key === 1">
                        {{ channel.name }}
                      </option>
                </select>
              </div>
              
              <!-- Gênero - Campo vertical -->
              <div class="customl-modal-add-form-group">
                <label class="customl-modal-add-form-label">{{ 'Gênero' }}</label>
                <select
                  v-model="new_lead.genre_key"
                  class="customl-modal-add-form-select"
                >
                  <option :value="null" disabled selected>{{ getTranslations('expression_566') }} </option>
                    <option :value="2">{{ getTranslations('expression_567') }}</option>
                  <option :value="0">{{ getTranslations('expression_568') }}</option>
                  <option :value="1">{{ getTranslations('expression_569') }}</option>
                </select>
              </div>
              
              <!-- Checkbox de consentimento -->
              <div class="customl-modal-add-consent-checkbox">
                <input 
                  type="checkbox" 
                  id="consent" 
                  class="consent-input" 
                  v-model="termsAccepted"
                />
                <label for="consent" class="consent-label" :class="{ 'error-text': termsError }">
                 {{ getTranslations('expression_1437')}}
                  <a href="https://beecrm.io/termos-de-uso/" target="_blank">{{getTranslations('expression_1329') }}</a> {{getTranslations('expression_1330') }}
                </label>
              </div>
              <span v-if="termsError" class="error-message">
                {{getTranslations('expression_1438')}}
              </span>
              
              <div class="customl-modal-add-form-note">
                <span class="customl-modal-add-required-field">*</span>
                {{ getTranslations("expression_618") || 'Campos obrigatórios' }}
              </div>
            </div>
            
            <div v-if="chat.lead_check.id" class="customl-modal-add-lead-check-container">
              <!-- ALERTAS -->
              <div class="customl-modal-add-alert-container">
                <div v-if="chat.lead_check.ticket" class="alert customl-modal-add-alert-warning">
                  <span>{{ getTranslations("expression_619") || 'Este contato já possui um ticket aberto' }}</span>
                  <button type="button" class="alert-close" @click="$event.target.parentNode.style.display='none'">
                    <i class="bx bx-x"></i>
                  </button>
                </div>
                <div v-else class="alert customl-modal-add-alert-warning">
                  <span>{{ getTranslations("expression_620") || 'Este contato já existe no sistema' }}</span>
                  <button type="button" class="alert-close" @click="$event.target.parentNode.style.display='none'">
                    <i class="bx bx-x"></i>
                  </button>
                </div>
              </div>

              <div class="customl-modal-add-lead-card">
                <div class="customl-modal-add-lead-info">
                  <div class="customl-modal-add-lead-avatar">
                    <img
                      class="customl-modal-add-avatar-img"
                      :src="chat.lead_check.avatar_url ? chat.lead_check.avatar_url : no_pic"
                      alt="Avatar"
                    />
                  </div>
                  
                  <div class="customl-modal-add-lead-details">
                    <div class="customl-modal-add-lead-name">
                      {{ (chat.lead_check.name ? chat.lead_check.name : "---") | truncate(20) }}
                    </div>
                    
                    <div class="customl-modal-add-lead-phone">
                      {{ chat.lead_check.phone ? chat.lead_check.phone : "---" }}
                    </div>
                    
                    <div class="customl-modal-add-lead-meta">
                      <div class="customl-modal-add-lead-channel">
                        <i :class="getChannelObject('id', chat.lead_check.channel_id).type ? getChannelObject('id', chat.lead_check.channel_id).type.icon : 'bx bx-mobile'"></i>
                        <span>{{ getChannelObject("id", chat.lead_check.channel_id).name | truncate(20) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div v-if="(chat.lead_check.ticket && this.$route.name !== 'Leads' && chat.lead_check.ticket.operator_id === isOperator(chat.lead_check.ticket.department_id)) || (!chat.lead_check.ticket && this.$route.name !== 'Leads')" class="lead-actions">
                  <button
                    v-if="chat.lead_check.ticket && this.$route.name !== 'Leads' && chat.lead_check.ticket.operator_id === isOperator(chat.lead_check.ticket.department_id)"
                    @click.prevent="show_ticket(chat.lead_check.ticket)"
                    class="btn-success"
                  >
                    {{ getTranslations("expression_621") || 'Ver ticket' }}
                  </button>
                  
                  <button
                    v-if="!chat.lead_check.ticket && this.$route.name !== 'Leads'"
                    @click.prevent="addlead_step = 3"
                    class="btn-primary"
                  >
                    {{ getTranslations("expression_157") || 'Criar ticket' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- FIM FORMULÁRIO -->

          <!-- CRIAÇÃO DE TICKET OU REDIRECIONAMENTO PARA UM TICKET QUE JÁ ESTÁ ABERTO -->
          <div v-if="addlead_step === 3" class="ticket-creation">
            <div class="customl-modal-add-lead-card-large">
              <div class="customl-modal-add-lead-info">
                <div class="customl-modal-add-lead-avatar">
                  <img
                    class="customl-modal-add-avatar-img"
                    :src="chat.lead_check.avatar_url ? chat.lead_check.avatar_url : no_pic"
                    alt="Avatar"
                  />
                </div>
                
                <div class="customl-modal-add-lead-details">
                  <div class="customl-modal-add-lead-name">
                    {{ (chat.lead_check.name ? chat.lead_check.name : "---") | truncate(20) }}
                  </div>
                  
                  <div class="customl-modal-add-lead-phone">
                    {{ chat.lead_check.phone ? chat.lead_check.phone : "---" }}
                  </div>
                  
                  <div class="customl-modal-add-lead-meta">
                    <div class="customl-modal-add-lead-channel">
                      <i :class="getChannelObject('id', chat.lead_check.channel_id).type ? getChannelObject('id', chat.lead_check.channel_id).type.icon : 'bx bx-mobile'"></i>
                      <span>{{ getChannelObject("id", chat.lead_check.channel_id).name | truncate(20) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="customl-modal-add-department-selection">
              <label class="customl-modal-add-form-label">{{ getTranslations("expression_12") || 'Departamento' }}</label>
              <select
                v-if="getOperatorsArray('user_id', me.data.id).length > 0"
                @change.prevent="walletCheck"
                v-model="chat.new_ticket.department_id"
                class="customl-modal-add-form-select">
                <option :value="null">
                  {{ getTranslations("expression_285") || 'Selecione' }}
                </option>
                <option
                  v-for="department in getDepartmentsArray('channel_id', chat.lead_check.channel_id)"
                  :key="department.id"
                  :value="department.id"
                  v-if="isOperator(department.id)">
                  {{ department.name }}
                </option>
              </select>
              <select
                v-else
                @change.prevent="walletCheck"
                v-model="chat.new_ticket.department_id"
                class="customl-modal-add-form-select">
                <option :value="null">
                  {{ getTranslations("expression_285") || 'Selecione' }}
                </option>
                <option 
                  v-for="department in getDepartmentsArray('channel_id', chat.lead_check.channel_id)"
                  :key="department.id"
                  :value="department.id">
                  {{ department.name }}
                </option>
              </select>
            </div>
          </div>
          <!-- FIM CRIAÇÃO DE TICKET -->
        </div>
        
        <!-- Modal Footer -->
        <div class="customl-modal-add-footer">
          <button type="button" class="btn-secondary" @click="closeModal">
            {{getTranslations('expression_355')}}
          </button>

          <!-- CASO O FORMULÁRIO AINDA NÃO TENHA SIDO PREENCHIDO DA MANEIRA CORRETA -->
      <span v-if="addlead_step === 2
                  && !chat.lead_check.ticket
                  && (new_lead.name.length < 2
                    || new_lead.channel_id === null
                    || new_lead.phone.length < 10)"
         class="btn-disabled">
        <span class="">{{ getTranslations("expression_623") }}</span>
      </span>
      <!-- CASO O FORMULÁRIO AINDA NÃO TENHA SIDO PREENCHIDO DA MANEIRA CORRETA -->

          
          <!-- BOTÃO CONTINUAR -->
        <button v-if="addlead_step === 2" 
            @click.prevent="verifyLead" 
            type="button"
            :disabled="loading_lead_check
                      || (new_lead.name.length < 2
                        || new_lead.channel_id === null
                        || new_lead.phone.length < 10
                        || !isFormValid)"
            :class="['btn-primary', {'btn-loading': loading_lead_check}]">
            <i :class="loading_lead_check ? 'bx-loader bx-spin' : 'bx-check'" class="bx bx-xs mr-1"></i>
            {{ this.$route.name === 'Leads' ? getTranslations("expression_120") || 'Salvar' : getTranslations("expression_1289") || 'Criar' }}
          </button>
          
          <!-- BOTÃO PARA CRIAR NOVO TICKET -->
          <button @click.prevent="newTicket"
                  v-if="addlead_step === 3
                        && chat.new_ticket.department_id > 0
                        && chat.wallet_check.id >= 0
                        && this.$route.name !== 'Leads'"
            type="button"
            class="btn-primary">
            <i class="bx bx-xs bx-check mr-1"></i>
            {{ getTranslations("expression_157") || 'Criar ticket' }}
          </button>
          
          <!-- INFORMATIVO FALANDO QUE O CONTATO NÃO PERTENCE AO ATENDENTE(MÓDULO CARTEIRA) -->
          <span v-if="addlead_step === 3
                      && chat.new_ticket.department_id > 0
                      && chat.wallet_check.id < 0"
            class="btn-disabled">
            <span>{{ getTranslations("expression_624") || 'Este contato não pertence a você' }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapState} from "vuex";
import VueCountryDropdown from "vue-country-dropdown";
import no_pic from "../../assets/img/no-pic-user.png"
import $ from "jquery";
import Swal from "sweetalert2";
import { get } from "lodash";

export default {
  props: {
    isVisible: Boolean,
  },
  name: "ModalAddLead",
  components: {
    VueCountryDropdown
  },
  computed: {
    ...mapState(['me', 'chat', 'channels', 'operators', 'configs']),
    ...mapGetters([
      'getChannelObject',
      'getDepartmentObject',
      'getUserObject',
      'getOperatorObject',
      'getDepartmentsArray',
      "getChatTicketsFilter",
    ]),
    isFormValid() {
      // Verifica se o email é válido (se preenchido) e se os termos foram aceitos
      const isEmailValid = this.new_lead.email ? !this.emailError : true;
      return isEmailValid && this.termsAccepted;
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.addlead_step = 2; 
      } else {
        this.resetForm(); 
      }
    },
   'new_lead.phone_without_ddi': function() {
      let phone_with_only_numbers = this.new_lead.phone_without_ddi.replace(/\D/g,""); //Remove tudo o que não é dígito
      this.new_lead.phone_without_ddi = phone_with_only_numbers;
      this.new_lead.phone = `${this.new_lead.phone_ddi}${phone_with_only_numbers}`;
    },
    'new_lead.email': function(newVal) {
      // Se o campo for limpo, remove o erro
      if (!newVal) {
        this.emailError = false;
      }
    },
    termsAccepted(val) {
      // Limpa o erro quando os termos são aceitos
      if (val) {
        this.termsError = false;
      }
    }
  },
  data() {
    return {
      isOpen: false,
      loading_lead_check: false,
      whatsapp_not_exists: false,
      verifying_if_lead_exists: false,
      error_when_verify_whatsapp: false,
      no_pic: no_pic,
      addlead_step: 1,
      new_lead: {
        name: "",
        phone_ddi:"",
        phone: "",
        phone_without_ddi: "",
        email: "",
        channel_id: null,
        genre_key: null
      },
      // Novos campos para validação
      emailError: false,
      termsAccepted: false,
      termsError: false
    }
  },
  mounted() {
    this.addlead_step = 2;


this.$nextTick(() => {
  $("#phoneNumber").val("");
});
    
    this.$root.$on('resetChannelIdOnCreateLead', () => {
      this.new_lead.channel_id = null;
    });

    this.$root.$on('setLoadingVerifyLeadFalse', () => {
  this.loading_lead_check = false;

  // só dispara createLead se os dados estiverem completos, nao duplicando eles
  const lead = this.new_lead;
  const isFilled = lead.name?.length > 1 && lead.channel_id && lead.phone?.length > 7;

  if (!this.chat.lead_check.ticket && this.chat.lead_check.id === undefined && !this.loading_lead_check && isFilled) {
    this.createLead();
  }
});


    window.VueComponent = this;
  },
  methods: {
    openModal() {
      this.$emit("open");
    },
    resetForm() {
      this.whatsapp_not_exists = false;
  this.new_lead = {
    name: "",
    lastName: "",
    phone_ddi: "",
    phone: "",
    phone_without_ddi: "",
    email: "",
    channel_id: null,
    genre_key: null,
  };
  this.$store.commit('SET_LEAD_CHECK', this.xeroxHelper({}));
  this.chat.wallet_check = {};
  this.chat.new_ticket = {
    department_id: null
  };

  this.addlead_step = 2;

  // Reset visual do campo de telefone, se necessário
  this.$nextTick(() => {
    $("#phoneNumber").val("");
  });
  this.termsAccepted = false;
  this.emailError = false;
  this.termsError = false;
  this.whatsapp_not_exists = false;
}
,
    // Método para validar o email
    validateEmail() {
      if (this.new_lead.email) {
        // Regex para validação de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.emailError = !emailRegex.test(this.new_lead.email);
      } else {
        // Se o campo estiver vazio, não mostra erro (não é obrigatório)
        this.emailError = false;
      }
    },
    onSelectDDI({name, iso2, dialCode}) {
      this.new_lead.phone_ddi = dialCode;
      // console.log(this.new_lead.phone_ddi);
    },
    closeModal() {
      //this.kanban_cards.current_card = this.kanban_cards.model_current_card;
      this.resetForm();
      this.$emit('close')
    },    
    createdLead() {
      this.$emit('close')
      this.$swal.fire({
        position: 'center',
        icon: 'success',
        title: this.getTranslations('expression_891'),
        showConfirmButton: false,
        timer: 2000
      })
    },
    goLeads() {
      this.$router.push({name: 'Leads'})
    },
    formatPhone(phone){
      setTimeout(() => {
        let phone_with_only_numbers = phone.replace(/\D/g,""); //Remove tudo o que não é dígito
        this.new_lead.phone = phone_with_only_numbers;
      }, 1800);
    },
    verifyLead() {
      this.leadCheck();
    },
    leadCheck() {
      this.$store.commit('SET_LEAD_CHECK', {})
      if (this.new_lead.name.length > 0 && this.new_lead.channel_id > 0 && this.new_lead.phone.length >= 7) {
        this.loading_lead_check = true;
        this.checkFormatNumber(this.new_lead.phone_without_ddi, this.new_lead.phone_ddi);
        // this.checkWhatsappNumber(this.new_lead.phone)
      }
    },
    checkFormatNumber(number, ddi) {
      // number = parseInt(number);
      ddi = parseInt(ddi);
      
      const dddsWithNinthDigit = [
        11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28
      ];
      let channel = this.getChannelObject('id', this.new_lead.channel_id);
      if(number.length > 8 && channel.type_key == 0) {

        if(ddi == 55) {
          // const regex = /^(\d{2})\s*(\d{4,5})(\d{4})$/
          const regex = /^(\d{2})(\d{4,5})(\d{4})$/
          const match = number.match(regex);

          if(match) {
            const ddd = parseInt(match[1]);
            const firstBlock = match[2];
            const secondBlock = match[3];

            if(!dddsWithNinthDigit.includes(ddd) && firstBlock.length == 5) {
              this.new_lead.phone = `${this.new_lead.phone_ddi}${ddd}${firstBlock.slice(1)}${secondBlock}`;
              this.new_lead.phone_without_ddi = `${ddd}${firstBlock.slice(1)}${secondBlock}`;
            }
            // this.$store.dispatch('getLeadCheck', this.new_lead)
          }
        }
        this.loading_lead_check = false;
        this.$store.dispatch('getLeadCheck', this.new_lead)
      }
    },
    checkWhatsappNumber(number) {
      let channel = this.getChannelObject('id', this.new_lead.channel_id);
      if(number.length > 8 && channel.type_key == 0) {
        api.post('https://whatsapp.beelabs.com.br/chat/whatsappNumbers/instance-verify',
          { numbers:[ number ] },
          { headers: { 'apikey': 'instance-verify' } }
        ).then((response) => {
          this.error_when_verify_whatsapp = false;
          if(response.data[0].exists == false) {
            this.loading_lead_check = false;
            this.whatsapp_not_exists = true;
          } else {
            this.whatsapp_not_exists = false;

            let jid = response.data[0].jid;
            let phone_number = jid.split('@')[0];
            this.new_lead.phone = phone_number;
            
            this.$store.dispatch('getLeadCheck', this.new_lead)
          };
        }).catch(error => {
          this.error_when_verify_whatsapp = true;
          this.$swal.fire({
            title: `${this.getTranslations('expression_213')}`,
            html: `${this.getTranslations('expression_214')}`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: 'btn-primary',
            confirmButtonText: `Ok`
            // confirmButtonText: `${this.getTranslations('expression_1289')}`
            // cancelButtonText: this.getTranslations('expression_355')
          })
        })
      }
    },
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    createLead() {
      // console.trace('createLead chamado!');
      // console.log('INFOS NOVO LEAD', this.new_lead);
      if(!this.error_when_verify_whatsapp || !this.whatsapp_not_exists) {
        // ANTES DE RETIRAR O INSTANCE-VERIFY DA CRIAÇÃO DE CONTATO
        // this.new_lead.status_key = 1;
        // ANTES DE RETIRAR O INSTANCE-VERIFY DA CRIAÇÃO DE CONTATO

        // DEPOIS
        this.new_lead.status_key = 0;
        // DEPOIS
        
        if (this.$route.name === 'Leads') {
          this.new_lead.route_name = 'Leads';
          this.$store.dispatch('newLead', this.new_lead)
          setTimeout(() => {
            this.$emit('close');
          }, 800)
        } else {
          // Caso o modal esteja sendo usado na tela do Chat, vai para o próximo passo
          // que é fazer abertura de ticket ou redirecionar para um ticket que já está aberto
          this.addlead_step = 3
          this.$store.dispatch('newLead', this.new_lead)
        }
      } else {
        if(this.error_when_verify_whatsapp) {
          this.$swal.fire({
            title: `${this.getTranslations('expression_213')}`,
            html: `${this.getTranslations('expression_214')}`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: 'btn-primary',
            confirmButtonText: `Ok`
          })
        } else {
          this.$swal.fire({
            title: `${this.getTranslations('expression_217')}`,
            text: `${this.getTranslations('expression_218')}`,
            // html: `Não foi possível `,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: 'btn-primary',
            confirmButtonText: `Ok`
          })
        }
        
      }
    },
    newTicket() {
      if (this.chat.new_ticket.department_id > 0) {
        this.chat.new_ticket.operator_id = this.isOperator(this.chat.new_ticket.department_id)
        this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
        this.chat.new_ticket.lead_id = this.chat.lead_check.id
        this.chat.lead_check.id = null;

        this.$store.dispatch('newTicket', this.chat.new_ticket)
        setTimeout(() => {
            this.$emit('close');
            this.resetForm();
          }, 700)
      }
    },
    walletCheck() {
      if (this.chat.new_ticket.department_id > 0) {
        this.chat.new_ticket.operator_id = this.isOperator(this.chat.new_ticket.department_id)
        this.chat.new_ticket.lead_id = this.chat.lead_check.id
        this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
        if (this.chat.new_ticket.department_id > 0) {
          this.$store.dispatch('getWalletCheck', this.chat.new_ticket)
        }
      }
    },
    show_ticket(payload) {
      // const ticket = this.getChatTicketsFilter(payload.status_keypayload.status_key).find(ticket => {
      const ticket = this.getChatTicketsFilter().find(ticket => {
        return ticket.id === payload.id
      })
      $('#pills-profile-tab').click()
      // console.log('ACHOU', ticket);
      this.$store.commit('SET_CHAT_TICKET', ticket)
      this.$store.dispatch('getHistoriesData', ticket.id)
      setTimeout(() => {
        document.getElementById('chat_conversation').scrollIntoView({block: "end", behavior: "smooth"});
      }, 500);
    },
  }
}

</script>

<style scoped>
/* Modal backdrop */
.customl-modal-add-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* Modal container */
.customl-modal-add-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 480px;
  max-height: 85vh;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Modal content */
.customl-modal-add-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* Modal header */
.customl-modal-add-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.header-content {
  display: flex;
  align-items: center;
}

.header-content h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.close-button {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.close-button i {
  color: #4a5568; 
  font-size: 22px; 
}

.close-button:hover i {
  color: #e9403a; 
}

.close-button:hover {
  transform: scale(1.1);
  opacity: 0.8;
}

.close-button:focus {
  outline: none;
}

/* Modal body */
.customl-modal-add-body {
  padding: 14px 16px;
  overflow-y: auto;
  flex: 1;
}

/* Form container */
.customl-modal-add-form-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Form groups - layout vertical */
.customl-modal-add-form-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.customl-modal-add-form-label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
}

.customl-modal-add-form-input, .customl-modal-add-form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #222529;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  height: 40px;
}

.customl-modal-add-form-input:focus, .customl-modal-add-form-select:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

/* Phone input container - layout horizontal */
.customl-modal-add-customl-modal-add-phone-input-container {
  display: flex;
  gap: 8px;
}

.country-dropdown {
  width: 100px;
  flex-shrink: 0;
}

/* Estilização para o dropdown de país */
.country-dropdown ::v-deep(.vue-country-dropdown) {
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.country-dropdown ::v-deep(.vue-country-dropdown .country-selector) {
  height: 40px;
  border-radius: 8px;
}

.country-dropdown ::v-deep(.vue-country-dropdown .country-selector .country-flag) {
  border-radius: 4px;
}

.country-dropdown ::v-deep(.vue-country-dropdown .country-selector .country-selector-input) {
  border-radius: 8px;
  height: 40px;
  padding: 10px 12px;
}

.customl-modal-add-phone-input {
  flex-grow: 1;
}

/* Consent checkbox */
.customl-modal-add-consent-checkbox {
  display: flex;
  align-items: flex-start;
  margin-top: 4px;
  gap: 8px;
}

.consent-input {
  margin-top: 3px;
}

.consent-label {
  font-size: 12px;
  color: #555;
  line-height: 1.4;
}

.error-text {
  color: #dc3545;
}

.terms-link {
  color: #007bff;
  text-decoration: none;
}

/* Required field */
.customl-modal-add-required-field {
  color: #dc3545;
  margin-left: 2px;
}

.customl-modal-add-form-note {
  font-size: 11px;
  color: #666;
  margin-top: 4px;
}

/* Error message */
.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

/* Lead check container */
.customl-modal-add-lead-check-container {
  margin-top: 16px;
  border-top: 1px solid #e0e0e0;
  padding-top: 16px;
}

/* Alert container */
.customl-modal-add-alert-container {
  margin-bottom: 12px;
}

.alert {
  padding: 10px 12px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.customl-modal-add-alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
}

.alert-close {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
}

/* Lead card */
.customl-modal-add-lead-card, .customl-modal-add-lead-card-large {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.customl-modal-add-lead-info {
  display: flex;
  gap: 12px;
}

.customl-modal-add-lead-avatar {
  position: relative;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.customl-modal-add-avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.customl-modal-add-lead-details {
  flex-grow: 1;
}

.customl-modal-add-lead-name {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
}

.customl-modal-add-lead-phone {
  color: #666;
  font-size: 13px;
  margin-bottom: 6px;
}

.customl-modal-add-lead-meta {
  display: flex;
  gap: 12px;
}

.customl-modal-add-lead-channel, .lead-time {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #777;
}

.lead-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

/* Ticket info */
.ticket-info {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.ticket-detail {
  display: flex;
  flex-direction: column;
}

.ticket-detail small {
  font-size: 11px;
  color: #777;
  margin-bottom: 2px;
}

.ticket-detail div {
  font-size: 13px;
}

/* Ticket creation */
.ticket-creation {
  margin-top: 12px;
}

.customl-modal-add-department-selection {
  margin-top: 12px;
}

/* Modal footer */
.customl-modal-add-footer {
  padding: 14px 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background-color: #f8f9fa;
}

/* Buttons */
.btn-primary, .btn-secondary, .btn-success, .btn-disabled {
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
}

.btn-primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}

.btn-primary:disabled {
  background-color: #80bdff;
  border-color: #80bdff;
  cursor: not-allowed;
  opacity: 0.65;
}

.btn-secondary {
  background-color: #f8f9fa;
  color: #212529;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.btn-success {
  background-color: #28a745;
  color: white;
  border: 1px solid #28a745;
}

.btn-success:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.btn-disabled {
  background-color: #e9ecef;
  color: #6c757d;
  border: 1px solid #ddd;
  cursor: not-allowed;
}

.btn-loading {
  position: relative;
  pointer-events: none;
}

/* Animations */
.animated--grow-in {
  animation-name: growIn;
  animation-duration: 0.2s;
  animation-timing-function: transform cubic-bezier(0.18, 1.25, 0.4, 1), opacity cubic-bezier(0, 1, 0.4, 1);
}

@keyframes growIn {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Ajustes para melhorar o layout vertical */
.mr-2 {
  margin-right: 8px;
}

.w-100 {
  width: 100%;
}

.cursor-default {
  cursor: default;
}
</style>